import { Component, Input } from '@angular/core';
import { ModalService } from '../../core/services/modal.service';

export interface IErrorModalOptions {
	title: string;
	text: string[];
	actions?: {
		type: string;
		text: string;
		callback?: (e: MouseEvent) => void;
	}[];
}

@Component({
	selector: 'app-new-error-modal',
	templateUrl: './new-error-modal.component.html',
	styleUrls: ['./new-error-modal.component.scss'],
})
export class NewErrorModalComponent {
	@Input() options: IErrorModalOptions;

	@Input() modalId;

	@Input() textList;

	constructor(
		private ms: ModalService,
	) { }

	close(id) {
		this.ms.close(id);
	}
}
